import { Link } from "react-router-dom";
import { ScrollReveal } from "@/components/ScrollReveal";
import { useLanguage } from "@/contexts/LanguageContext";

export function WhitepaperTeaserSection() {
  const { language, localizedPath } = useLanguage();
  const isDe = language === "de";

  const headline = isDe
    ? "Der Guide für Brands, die einsteigen wollen."
    : "The guide for brands ready to get started.";

  const text = isDe
    ? "Micro Drama: Alles, was Brands jetzt wissen müssen — Marktüberblick, Use Cases von KFC bis Bugatti Fashion, Story-Struktur und der schnellste Weg zur ersten eigenen Serie."
    : "Micro Drama: everything brands need to know now — market overview, use cases from KFC to Bugatti Fashion, story structure and the fastest route to your first own series.";

  return (
    <section className="py-32 md:py-40 px-6">
      <div className="max-w-[1400px] mx-auto">
        <ScrollReveal>
          <p className="text-label mb-8">WHITEPAPER</p>
        </ScrollReveal>

        <ScrollReveal delay={100}>
          <h3 className="font-display text-3xl md:text-5xl font-bold tracking-tight max-w-3xl">
            {headline}
          </h3>
        </ScrollReveal>

        <ScrollReveal delay={200}>
          <p className="mt-6 text-body-md text-muted-foreground max-w-2xl leading-relaxed">
            {text}
          </p>
        </ScrollReveal>

        <ScrollReveal delay={300}>
          <Link
            to={localizedPath("/whitepaper")}
            className="inline-flex items-center mt-12 px-10 py-4 rounded-full bg-accent text-accent-foreground text-sm font-medium uppercase tracking-wider hover:opacity-90 transition-opacity"
          >
            {isDe ? "WHITEPAPER SICHERN" : "GET THE WHITEPAPER"} →
          </Link>
        </ScrollReveal>
      </div>
    </section>
  );
}
